// TODO: remove in favor of date-fns
export function subtractDaysFromDate(days: number, to: Date = new Date()): Date {
  const from = new Date();
  from.setDate(to.getDate() - days);
  return from;
}
